<script lang="ts" setup>
import type { ChangeEmployeeStatusProps } from '@modules/employees/components/types';
import type { EmployeeListItemResponse } from '@modules/employees/types';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import { useConfirmDialogs } from '@modules/core/composables/dialogs';
import { TRANSLATION_GROUP_EMPLOYEES_LIST } from '@modules/employees/constants';
import { useChangeEmployeeStatusMutation } from '@modules/employees/mutations';
import { useI18n } from '@modules/i18n/composables';

defineProps<ChangeEmployeeStatusProps>();

const { confirmDelete } = useConfirmDialogs();
const { getTranslation } = useI18n();

const { mutate: changeStatus, isLoading: isChanging } = useChangeEmployeeStatusMutation();

function onBlock(event: Event, employee: EmployeeListItemResponse): void {
  confirmDelete({
    event,
    header: employee.banned
      ? getTranslation(TRANSLATION_GROUP_EMPLOYEES_LIST, 'TITLE_BANNED').value
      : getTranslation(TRANSLATION_GROUP_EMPLOYEES_LIST, 'TITLE_UNBANNED').value,
    message: employee.banned
      ? `${getTranslation(TRANSLATION_GROUP_EMPLOYEES_LIST, 'MESSAGE_BANNED', { replace: { name: employee.name } }).value}`
      : `${getTranslation(TRANSLATION_GROUP_EMPLOYEES_LIST, 'MESSAGE_UNBANNED', { replace: { name: employee.name } }).value}`,
    acceptLabel: getTranslation(TRANSLATION_GROUP_EMPLOYEES_LIST, 'YES_BANNED').value,
    rejectLabel: getTranslation(TRANSLATION_GROUP_EMPLOYEES_LIST, 'NO_BANNED').value,
    accept: () => {
      changeStatus(employee.id);
    },
  });
}
</script>

<template>
  <VIconButton v-data-qa-auto-id="'ChangeEmployeeStatus'"
    :loading="isChanging"
    :icon="listItem.banned ? 'pi-lock' : 'pi-lock-open'"
    @click="onBlock($event, listItem)"
  />
</template>
